<div class="card">
  <div class="info-container">
    <i class="icon ic-info-circle-20"></i>
    <div class="text">{{ pageInfo }}</div>
  </div>

  <form
    [formGroup]="form"
    class="search-container mt-2 d-flex gap-16"
  >
    <div class="d-flex gap-16 flex-grow-1">
      @if (showSearchBar) {
        <app-flags-autocomplete
          label=""
          switchBtnText=""
          class="country-select"
          formControlName="country"
        />

        <app-address-autocomplete
          class="flex-grow-1 autocomplete-container"
          placeholder="Type Entity Name or Address that you want to change"
          [formControl]="searchControl"
          [showBulkSearch]="true"
          [dataStatus]="addressStatus"
          [useInternationalAddresses]="true"
          [isAustraliaSelected]="isAustraliaSelected()"
          [country]="form.value.country ?? ''"
          [clearStatusAfter]="5000"
          [isDisabled]="isDisabled || this.modalOpened()"
          (onSelect)="parseAddress($event)"
          (onTextChange)="textChange($event)"
        />
      }
    </div>

    @if (searchControl.value?.trim()) {
      <app-button
        type="submit"
        text="Continue"
        iconClassLast="icon ic-arrow-right-20"
        [isDisabled]="bulkMatchesSelected.length == 0"
        (clickBtn)="bulkChangeAddress()"
      />
    }
  </form>

  @if (searchControl.value?.trim() || bulkRowData.length) {
    <div class="card-body">
      <app-list-grid-client-side
        [colDefs]="colDefs()"
        [rowData]="bulkRowData"
        [rowSelection]="bulkChangesRowSelection"
        [suppressRowClickSelection]="suppressRowClickSelection"
        [paginationPageSizeSelector]="paginationPageSizeSelector"
        [suppressCellFocus]="suppressCellFocus"
        [paginationPageSize]="pageSizeService.getPageSize"
        (selectAll)="selectAllItems($event)"
      />
    </div>
  } @else {
    <div class="bulk-changes-container">
      <div class="title">Other Bulk Changes</div>
      <div class="bulk-wrapper">
        @for (bulk of bulkChanges; track $index) {
          <a class="bulk-item" [routerLink]="bulk.link">
            <div>
              <i class="icon ic-arrow-right-20"></i>
            </div>

            <div class="d-flex flex-column gap-12">
              <div class="title">{{ bulk.title }}</div>
              <div class="description">{{ bulk.description }}</div>
            </div>
          </a>
        }
      </div>
    </div>
  }
</div>
